export const DATE_FORMAT_WITHOUT_TIME = 'll';
export const DATE_FORMAT_WITH_TIME = 'lll';

export const LOCALE_FOR_TESTS = 'en';
